import React, { useEffect, useState, Suspense } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
  fetchSurgeons,
  onSurgeonSelect,
  setSelectedSurgeons,
} from '../../store/action/surgeon.action'
import { Table, Avatar, Row, Col, message, Checkbox } from 'antd'
import util from '../../util/util'
import { formatPhoneNumberIntl } from 'react-phone-number-input'
import '../../css/patient.scss'
import { constants } from '../../constants'

const SurgeonTable = (props) => {
  var history = useHistory()
  useEffect(() => {
    fetchSurgeonsList(
      { current: 1, pageSize: 20 },
      { order: 'ascend', field: 'surgery' }
    )
    props.setSelectedRows([])
  }, [])

  var fetchSurgeonsList = (pagination, sorter) => {
    props.fetchSurgeons({
      customerid: props.customer?._id,
      pagination,
      searchText: props.searchText,
      sorter,
    })
  }

  var formatdata = (data) => {
    data && data.forEach((e, i) => (e.key = e._id))
    return data
  }

  var dataSource = formatdata(props.surgeons)
  var pagination = {
    ...props.pagination,
    showSizeChanger: true,
  }

  var handleRowSelect = (e, surgeon) => {
    e.stopPropagation()
    props.onRowSelect({
      surgeon,
      surgeons: props.selectedSurgeons,
      flag: e.target.checked,
    })
  }

  var renderName = (name, obj) => {
    return (
      <Row className={'nameRow'}>
        <Avatar src={obj?.image}>{obj?.name[0]?.toUpperCase()}</Avatar>
        <span>{_.upperFirst(obj.name)}</span>
      </Row>
    )
  }

  var handleRowClick = (record) => {
    history.push({ pathname: 'surgeons/edit', state: record })
  }

  var handleRow = (record, rowIndex) => {
    return {
      onClick: () => handleRowClick(record),
    }
  }

  var formatNumber = (phone) => {
    var number = phone.toString()
    if (number) {
      if (number.length > 10)
        number = number?.charAt(0) == '+' ? number : '+' + number
      else number = number?.charAt(0) == '+' ? '1' + number : '+1' + number
      return number
    }
  }

  const handlePreviewClick = (_id) => {
    var path = window.location.pathname
    var url = window.location.href
      .replace(path, '/surgeon/')
      .replace('admin', 'profiles')
    window.open(url + _id)
  }

  const columns = [
    {
      title: 'NAME',
      render: (name, obj) => renderName(name, obj),
    },
    {
      title: 'EMAIL',
      dataIndex: 'email',
      align: 'center',
    },
    {
      title: 'PHONE',
      align: 'center',
      render: (name, obj) =>
        formatPhoneNumberIntl(formatNumber(obj?.phone?.public)),
    },
    {
      title: 'PATIENTS',
      dataIndex: 'patients',
      align: 'center',
    },
    // {
    //     title: 'ACCESS CODE',
    //     dataIndex: 'accesscode',
    //     align: 'center',
    // },
    {
      title: 'Actions',
      align: 'center',
      render: (row, obj) => (
        <Row justify='center' onClick={(e) => e.stopPropagation()}>
          <a
            id={'surgeonqr'}
            style={{ textDecoration: 'underline' }}
            href={constants.API_URL + '/qrcode/' + row._id + '/-1'}
            target='_blank'
          >
            Download qrcode
          </a>
          &nbsp; &nbsp;
          <a
            id={'surgeonpreview'}
            style={{ textDecoration: 'underline' }}
            onClick={() => handlePreviewClick(row._id)}
          >
            {' '}
            Preview{' '}
          </a>
        </Row>
      ),
    },
    {
      title: 'SELECT',
      align: 'center',
      render: (row, obj) => (
        <Row justify='center' onClick={(e) => e.stopPropagation()}>
          <Checkbox
            onChange={(e) => handleRowSelect(e, obj)}
            checked={_.find(props.selectedSurgeons, { _id: obj._id })}
          />
        </Row>
      ),
    },
  ]

  const components = {
    table: (props) => <table {...props} />,
    header: {
      wrapper: (props) => <thead id='surgeonview' {...props} />,
    },
  }

  return (
    <>
      <Table
        size={'large'}
        className={'custom-table'}
        columns={columns}
        dataSource={dataSource}
        loading={props.isLoading}
        pagination={pagination}
        onChange={fetchSurgeonsList}
        bordered={false}
        onRow={handleRow}
        components={components}
      />
    </>
  )
}

SurgeonTable.propTypes = {
  fetchSurgeon: PropTypes.func.isRequired,
  surgeons: PropTypes.array,
  sorter: PropTypes.object,
  searchText: PropTypes.string,
  pagination: PropTypes.object,
  isLoading: PropTypes.bool,
  selectedSurgeons: PropTypes.array,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    surgeons: state.surgeon.pageSurgeons,
    sorter: state.surgeon.sorter,
    searchText: state.surgeon.searchText,
    pagination: state.surgeon.pagination,
    isLoading: state.surgeon.isLoading,
    selectedSurgeons: state.surgeon.selectedSurgeons,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSurgeons: (params) => dispatch(fetchSurgeons(params)),
    onRowSelect: (params) => dispatch(onSurgeonSelect(params)),
    setSelectedRows: (surgeons) => dispatch(setSelectedSurgeons(surgeons)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SurgeonTable)
